import { memo as Memo } from 'react';

//* Components
import CustomLottie from '../../CustomLottie';

//* JSONs
import ziggyJSON from './ziggyJSON.json';

//* Styles
import ZiggyStyle from './style';

const Ziggy = Memo(() => {
	return (
		<ZiggyStyle className={'ziggy'}>
			<CustomLottie animData={ziggyJSON} />
		</ZiggyStyle>
	);
});

export default Ziggy;
